<p-scrollPanel [style]="{ width: '250px', height: '100%' }">
  <p-panelMenu
    [model]="menuItems"
    [style]="{ width: '250px' }"
    [multiple]="true"
  ></p-panelMenu>
</p-scrollPanel>
